import { CustomerOverview } from '@/components/customer/customer-overview'
import { CustomerDashboard } from '@/components/customer/dashboard'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/customer/$customerId/')({
  component: RouteComponent,
})
import { store } from '@/state/breadcrumb-store'

function RouteComponent() {
  const { customerId } = Route.useParams()

  store.trigger.changePath({
    newPath:
      [{ params: {}, to: "/customer", label: "Customer" },
      { params: { customerId: customerId }, to: "/customer/$customerId", label: customerId }]
  })


  return <CustomerOverview customerId={customerId}></CustomerOverview>

}
